import { DocumentIcon } from '@all-manager/design-system-v2';
import { DocumentType } from "../../../types";

// The design system has a single documents icon: photos show a thumbnail where one is available.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getDocumentIcon = (_type: DocumentType) => <DocumentIcon fontSize="small" />;
